/**
 * GOTHIC_ARCHETYPE
 *
 * The "Ground Truth" statistical profile for the Gothic Genre.
 * Features:
 * - Heavy, Slow March (4 bars/chord).
 * - Massive Low End (Organ/Bass).
 * - Dissonance is high (Minor/Diminished).
 * - "Wall of Doom" Voice Distribution.
 */

import { HORROR_ARCHETYPE } from './HorrorArchetype.js';

export const GOTHIC_ARCHETYPE = {
    ...HORROR_ARCHETYPE,

    // Harmonic Rhythm: Slow March.
    // 4 bars per chord is typical for a funeral march or procession.
    harmonicRhythm: {
        target: 4.0,
        tolerance: 2.0,
        weight: 0.3
    },

    // Harmonic Consonance: Dissonant / Minor.
    harmonicConsonance: {
        polarity: 'dissonant',
        weight: 0.2
    },

    // Voice Distribution: "Bottom Heavy".
    // Massive Lows (Organ Pedals, Basses).
    voiceDistribution: {
        low: 0.50,  // Very Heavy Lows
        mid: 0.30,  // Choir/Organ Manuals
        high: 0.20, // Sparse Highs
        tolerance: 0.20,
        tuttiThreshold: 0.8,
        weight: 0.3
    },

    // Dynamic Range: Heavy, consistent weight.
    dynamicRange: {
        minVariance: 0.10,
        targetVariance: 0.20,
        dynamicShape: 'linear',
        weight: 0.2
    },

    // Interval Entropy: Static or Stepwise.
    intervalEntropy: {
        stepRatio: 0.70, // Melodies are often chant-like (stepwise)
        tolerance: 0.20,
        weight: 0.1
    }
};
